/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import useSearchParams from '../../../hooks/use-search-params';

const useAccountAddressFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('search') || '';
  const page = searchParams.get('page') || '1';
  const limit = 20;

  const memoizeParams = useMemo(() => ({
    search,
    page,
    limit,
  }), [page, search])

  return memoizeParams;
};

export default useAccountAddressFilter;
